// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-balance-container{position:relative;width:100%}.home-balance-container .proceed{height:32px;width:32px;border:1px solid var(--v-textColor-base);border-radius:50%}.home-balance-container .proceed i{padding-left:2px;padding-top:1px}", ""]);
// Exports
module.exports = exports;
